module.exports = __webpack_public_path__ + "static/img/AO.182ddd10.svg";